module.exports = __webpack_public_path__ + "img/1.0d1e0da7.jpg";